import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectUserCityId} from 'modules/locations/selectors';
import {ICity} from 'modules/locations/models';
import {CookieService} from 'core/services/CookieService';
import {CITY_ID_KEY} from 'modules/locations/constants';

export const useUserCityId = (): ICity['id'] | null => {
    const cookiesService = CookieService.getInstance();
    const userCityId = useAppSelector(selectUserCityId);

    return userCityId || Number(cookiesService.get(CITY_ID_KEY)) || null;
};
